import React from "react";
import "./AirplaneLoader.scss";
import plane from "../../../core/common/assets/planeSvg.svg";

interface Props {
  text?: string;
  size?: "large" | "small";
  className?: string;
}

const AirplaneLoader: React.FC<Props> = ({
  text = "Finding the best flights for you...",
  size = "large",
  className = "",
}) => {
  const isSmall = size === "small";
  return (
    <div className={`flight-loader ${size} ${className}`}>
      <div className="sky">
        {/* Cloud layers (two copies each for looping) */}
        {/* <div className="cloud-layer layer-1">
          <div className="cloud cloud-1"></div>
          <div className="cloud cloud-1 duplicate"></div>
        </div>

        <div className="cloud-layer layer-2">
          <div className="cloud cloud-2"></div>
          <div className="cloud cloud-2 duplicate"></div>
        </div>

        <div className="cloud-layer layer-3">
          <div className="cloud cloud-3"></div>
          <div className="cloud cloud-3 duplicate"></div>
        </div> */}

        {/* Plane & trails */}
        <div className="plane-wrapper">
          <div className="trail-line tl1"></div>
          <div className="trail-line tl2"></div>
          <div className="trail-line tl3"></div>
          <img src={plane} alt="Loading airplane" className="plane" />
        </div>
      </div>
      {!isSmall && <p className="loader-text">{text}</p>}
    </div>
  );
};

export default AirplaneLoader;
